import { ServiceData } from '@/types';

import articles from './ASTROLOGY_ARTICLES_DE.json';
import audios from './ASTROLOGY_AUDIOS_DE.json';

export const ASTROLOGY_DATA_DE: ServiceData = {
  articles,
  audios,
};
